const LOCAL_SESSION_KEY_PREFIX = 'goformz.session.';
const OIDC_STORAGE_KEY_PREFIX = 'oidc.';

const getLocalSessionKey = (key: string) => `${LOCAL_SESSION_KEY_PREFIX}${key}`;

export const LocalSessionKeys = Object.freeze({
  accountDeleted: getLocalSessionKey('accountDeleted'),
  inactivityLastActiveTime: getLocalSessionKey('iat.lastactivetime'),
  inactivityTimeout: getLocalSessionKey('iat.timeout'),
  logout: getLocalSessionKey('logout'),
  regionCode: getLocalSessionKey('regionCode'),
  siftSessionId: getLocalSessionKey('siftSessionId'),
  switchAccount: getLocalSessionKey('switchAccount')
});

export function clearLocalSession() {
  const keysToRemove: string[] = [];

  for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i);
    if (key?.startsWith(LOCAL_SESSION_KEY_PREFIX) || key?.startsWith(OIDC_STORAGE_KEY_PREFIX)) {
      keysToRemove.push(key);
    }
  }

  keysToRemove.forEach((key) => localStorage.removeItem(key));
}
